import firebase from "@/firebase/init";
import "firebase/storage";

export default firebase.storage();
